'use client';
import Image, { StaticImageData } from 'next/image';
import Link from 'next/link';
import { ChevronRightIcon } from 'tdesign-icons-react';

interface IProdCardProps {
  icon: string | StaticImageData;
  title: string;
  subTitle: string;
  desc: string;
  linkHref?: string;
}

export const ProdCard: React.FC<IProdCardProps> = ({
  icon,
  title,
  desc,
  subTitle,
  linkHref,
}) => {
  const content = (
    <div className="p-5 rounded-lg bg-white h-full shadow-card">
      <div className="flex">
        <Image
          src={icon}
          alt="图标"
          width={40}
          height={40}
          className="w-10 h-full max-h-10"
        />
        <div className="ml-5 flex flex-col">
          <span className="text-base -leading-[1px] font-500 text-primary mobile:text-sm flex items-center">
            {title}
            {linkHref && (
              <ChevronRightIcon className="ml-1 text-xl mobile:text-base" />
            )}
          </span>
          <span className="mt-2 text-sm leading-none font-400 text-primary/[.6] mobile:text-xs min-h-5 mobile:min-h-4">
            {subTitle}
          </span>
        </div>
      </div>

      <div className="h-px w-full bg-primary/[.08] my-5 mobile:my-[10px]" />
      <div className="ml-[60px]">
        <p className="min-h-10 mobile:min-h-8 line-clamp-2 font-400 text-primary text-sm mobile:text-xs break-all">
          {desc}
        </p>
      </div>
    </div>
  );
  if (linkHref) {
    return (
      <Link href={linkHref} target="_blank">
        {content}
      </Link>
    );
  }
  return content;
};
